import React, { useRef, useEffect, useState, memo, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import MapBox from './MapBox';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Drawer } from '@material-ui/core';
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2)
    },
    hide: {
        display: "none"
    },
    drawer: {
        flexShrink: 0,
    },
    drawerPaper: {
        [theme.breakpoints.up("xs")]: {
            width: "50vw",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
        height: "100%",
        pointerEvents: "auto",
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: "flex-start"
    },
    labels: {
        //padding: "0px 16px 0px 16px"
        margin: "0px"
    }
}));

const SideView = ({ open, setOpen, children, cnt }, ref) => {

    //const theme = useTheme();
    const classes = useStyles();
    return (
        <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="right"
            open={open}
            onClose={() => setOpen(false)}

            classes={{
                paper: classes.drawerPaper
            }}
        >
            <div ref={ref}>
                {children}
            </div>
        </Drawer>
    );
}

export default memo(forwardRef(SideView));